module.exports = __webpack_public_path__ + "img/book.e1e31d56.jpg";